<template>
  <v-dialog
    class="view-table-dialog rounded-0"
    v-model="toggle"
    width="800"
    persistent
  >
    <v-card class="rounded-0">
      <v-app-bar dense dark class="rounded-0">
        <v-toolbar-title class="rounded-0">Impersonate User</v-toolbar-title>
      </v-app-bar>
      <v-card-text>
        <v-row
          ><v-col cols="12"
            ><app-search
              class="my-3"
              @search="onGridSearch"
            ></app-search></v-col
        ></v-row>
        <v-row>
          <v-col cols="12">
            <ag-grid-vue
              class="ag-theme-alpine"
              rowSelection="single"
              style="width: 100%; height: 60vh"
              :columnDefs="tblHeaders"
              :defaultColDef="tblColDefs"
              :rowData="
                filteredItems.filter(
                  (x) =>
                    x.company.toLowerCase().includes(keyword.toLowerCase()) ||
                    x.name.toLowerCase().includes(keyword.toLowerCase()) ||
                    x.oneLoginEmail.includes(keyword.toLowerCase())
                )
              "
              :gridOptions="gridOptions"
              @row-selected="onRowSelected"
              @grid-ready="onGridReady"
            >
            </ag-grid-vue>
          </v-col>
        </v-row>
        <v-row
          ><v-col cols="12" class="text-right"
            ><v-btn class="error" text @click="cancelImpersonate"
              >Cancel</v-btn
            ></v-col
          ></v-row
        >
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "ImpersonateTable",
  props: {
    toggle: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    AgGridVue,
  },
  data: () => ({
    keyword: "",
    tblHeaders: [
      {
        headerName: "Company",
        field: "company",
      },
      {
        headerName: "User",
        field: "name",
      },
      {
        headerName: "E-mail",
        field: "oneLoginEmail",
      },
    ],
    tblColDefs: {
      sortable: true,
      filter: true,
      resizeable: true,
    },
    gridOptions: {},
    tblItems: [],
  }),
  mounted() {
    let vm = this;

    if (!vm.wholesalers || vm.wholesalers.length === 0) vm.tblItems = [];

    vm.tblItems =
      vm.wholesalers &&
      vm.wholesalers.filter(
        (x) =>
          x.oneLoginEmail !== null && x.oneLoginEmail.match(/^ *$/) === null
      );
  },
  computed: {
    filteredItems: function () {
      let vm = this;

      if (vm.wholesalers.length === 0) return [];

      return (
        vm.wholesalers &&
        vm.wholesalers.filter(
          (x) =>
            x.oneLoginEmail !== null && x.oneLoginEmail.match(/^ *$/) === null
        )
      );
    },
    // tblItems: function(){
    //     let vm = this;
    //     return [];
    //     // return vm.wholesalers.filter(x => x.oneLoginEmail !== null && x.oneLoginEmail.match(/^ *$/) === null);
    // }
  },
  methods: {
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
      vm.gridApi.sizeColumnsToFit();
    },
    onGridSearch(keyword) {
      let vm = this;
      vm.keyword = keyword;
    },
    onRowSelected(args) {
      let vm = this;
      let payload = {
        id: 0,
        impersonateEmail: args.data.oneLoginEmail,
      };

      vm.getFeatures(args.data.accountNumber);

      vm.setImpersonate(payload).then(() => {
        vm.$router.go(0);
      });
    },
    cancelImpersonate() {
      this.$emit(`onImpersonateClose`);
    },
  },
};
</script>